import { Container, Flex, Heading, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import OPEN_BOX_ICON from '@/assets/images/presentation/box-open-icon.png';
import CONSULTATIONS_ICON from '@/assets/images/presentation/consultation-icon.png';
import SUPPORT_ICON from '@/assets/images/presentation/support-icon.png';

import { WhyReasons } from '@/components/ui/features/presentation/PresentationReviews/components/WhyReasons';
import { RedCardWithDownloadButton } from '@/components/ui/shared/cards/RedCardWithDownloadButton/RedCardWithDownloadButton';

export const DetailsSection = () => {
  const { t } = useTranslation();

  return (
    <Container textAlign="center" pb={20}>
      <Flex maxW="800px" flexDirection="column" margin="auto">
        <Flex flexDirection="column" alignItems="center">
          <Text fontFamily="heading" fontSize="3xl">
            {t('audioVisualPage.detailsHeading.0')}
            <Text as="span" lineHeight={1} fontSize="3xl" fontFamily="heading" fontWeight="bold" color="violet.500">
              {t('audioVisualPage.detailsHeading.1')}
            </Text>
          </Text>
          <Text mt={6}>{t('audioVisualPage.detailsDescription')}</Text>
        </Flex>
        <Flex mt={8} flexDirection="column" alignItems="center">
          <Text fontFamily="heading" fontSize="3xl">
            {t('audioVisualPage.scientificConferenceHeading.0')}
            <Text as="span" lineHeight={1} fontSize="3xl" fontFamily="heading" fontWeight="bold" color="violet.500">
              {t('audioVisualPage.scientificConferenceHeading.1')}
            </Text>
          </Text>
          <Text mt={6}>{t('audioVisualPage.scientificConferenceDescription')}</Text>
        </Flex>
      </Flex>
      <Heading fontSize="3xl" mt={16}>
        {t('audioVisualPage.serviceWeOfferHeading')}
      </Heading>
      <Flex mt={12} gap={8} flexWrap="wrap" justifyContent="center">
        <WhyReasons
          w="312px"
          src={SUPPORT_ICON}
          alt={t('audioVisualPage.serviceWeOffer.0.title')}
          title={t('audioVisualPage.serviceWeOffer.0.title')}
          description={t('audioVisualPage.serviceWeOffer.0.description')}
        />
        <WhyReasons
          w="312px"
          src={CONSULTATIONS_ICON}
          alt={t('audioVisualPage.serviceWeOffer.1.title')}
          title={t('audioVisualPage.serviceWeOffer.1.title')}
          description={t('audioVisualPage.serviceWeOffer.1.description')}
        />
        <WhyReasons
          w="312px"
          src={OPEN_BOX_ICON}
          alt={t('audioVisualPage.serviceWeOffer.2.title')}
          title={t('audioVisualPage.serviceWeOffer.2.title')}
          description={t('audioVisualPage.serviceWeOffer.2.description')}
        />
      </Flex>
      <Flex mt={8} flexDirection="column" alignItems="center" maxW="800px" marginX="auto">
        <Text fontFamily="heading" fontSize="3xl" color="violet.500" fontWeight="bold">
          {t('audioVisualPage.moreThanAvHeading.0')}
          <Text as="span" lineHeight={1} fontSize="3xl" fontFamily="heading" fontWeight="normal" color="black">
            {t('audioVisualPage.moreThanAvHeading.1')}
          </Text>
        </Text>
        <Text mt={6}>{t('audioVisualPage.moreThanAvDescription')}</Text>
      </Flex>
      <RedCardWithDownloadButton
        slug="av-guide"
        mt={16}
        maxW="1000px"
        mx="auto"
        smallHeading={t('audioVisualPage.redCardSubheading')}
        heading={t('audioVisualPage.redCardHeading')}
      />
    </Container>
  );
};
